// latest: zhangmyh 2017-12-9 5:14 PM
// 资质库参照
import Collection from 'common/vo/collection'
import 'collection/qualify'
import 'collection/qualify/qualifyClass'
import { findIndex } from 'lodash'
import { Get, URLs } from 'common'
/* global $ u */

let _config
async function init (refer) {
  // 树形控件加载有误,所以需要每次都重新加载
  let collection = Collection.create('collection.qualify')
  let tree = Collection.create('collection.qualifyclass')
  let selectedData = []
  let selectflag = false
  await tree.load({ parentId: _config.parentId })

  let vm = {
    treemodel: tree.datatable,
    treeOption: {
      callback: {
        beforeClick: async function (id, obj) {
          if (!obj.flag) {
            let { data } = await Get(URLs.qf_class.url, {
              parentId: obj.id
            })
            if (data && data.result && data.result.length > 0) {
              tree.datatable.addSimpleData(data.result)
            }
            obj.flag = true
          }
          collection.datatable.removeAllRows()
          collection.load({
            qualifyTypeId: obj.id
          })
        }
      }
    },
    gridconfig: {
      id: 'gridqualify',
      data: collection,
      type: 'grid',
      multiSelect: _config.multiSelect,
      editable: false,
      pagination: true,
      fields: [{
        field: 'qualifyCode',
        dataType: 'String',
        title: '编码',
        width: '33%'
      }, {
        field: 'qualifyName',
        dataType: 'String',
        title: '名称',
        width: '33%'
      }, {
        field: 'qualifyDescription',
        dataType: 'String',
        title: '描述',
        width: '33%'
      }]
    }
  }

  let app = u.createApp()
  app.init(vm, $('#qualify_refer')[0])
  refer.registerSubmitFunc(() => {
    return selectedData
  })

  collection.on('data', function (result) {
    selectflag = false
    if (_config.multiSelect && !_config.repeatable && refer.options.defaultData) {
      if (selectedData.length <= 0) {
        // 初始化默认值
        let defaultData = refer.options.defaultData()
        if (defaultData instanceof Array) {
          selectedData = defaultData
        }
      }

      let SelectIndex = []
      result.data.result.forEach(function (listItem, i) {
        selectedData.forEach(function (item) {
          if (item.id === listItem.id) {
            SelectIndex.push(i)
          }
        })
      })
      collection.datatable.setRowsSelect(SelectIndex)
    }
    selectflag = true
  })

  collection.datatable.on('unSelect', function (obj) {
    let selectData = collection.datatable.getRowByRowId(obj.rowIds[0])
    /* let isBasic = selectData.data.isBasic.value
    if (!_config.canRemoveBasic && _config.multiSelect &&
      (isBasic == 1 || isBasic == 3 || isBasic == 5)) {
      setTimeout(function () {
        collection.datatable.addRowsSelect(obj.indices)
      }, 25)
      return
    } */
    let index = findIndex(selectedData, ['id', selectData.data.id.value])
    if (index >= 0) {
      selectedData.splice(index, 1)
    }
  })

  collection.datatable.on('select', function (obj) {
    if (!_config.multiSelect) {
      let selectData = collection.datatable.getCurrentRow().data
      let filepath = selectData.filePath.value
      if (!filepath) {
        filepath = ''
      }
      selectedData = {
        id: selectData.id.value,
        name: selectData.qualifyName.value,
        code: selectData.qualifyCode.value,
        typeId: selectData.qualifyTypeId.value,
        typeName: selectData.qualifyTypeName.value,
        url: filepath
      }
      refer.submit()
      return
    }
    // 默认初始化已选择数据的时候不触发数据改变
    if (selectflag) {
      let selectData = collection.datatable.getRowByRowId(obj.rowIds[obj.rowIds.length - 1]).data
      let index = findIndex(selectedData, ['id', selectData.id.value])
      if (index >= 0) {
        return
      }
      let filepath = selectData.filePath.value
      if (!filepath) {
        filepath = ''
      }
      selectedData.push({
        id: selectData.id.value,
        name: selectData.qualifyName.value,
        code: selectData.qualifyCode.value,
        typeId: selectData.qualifyTypeId.value,
        typeName: selectData.qualifyTypeName.value,
        // desc: selectData.qualifyDescription.value,
        // demand: selectData.approveDemand.value,
        // necessary: selectData.necessary.value,
        url: filepath
      })
    }
  })
}

let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    parentId: 0,
    canRemoveBasic: false,
    multiSelect: true,
    repeatable: false
  }, config)

  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/qualify/index.js